import React, { useEffect, useState, useRef } from "react";
import { getEventObject } from "../../../utils/EventUtils";
import { getValueOrDefault } from "../../../utils/ModalUtils";
import { quantityTypeNames, getQuantityName, getQuantityValue } from "../../../utils/QuantityUtils";

/**
 * props:
 * - amount
 * - multiplier
 * - onChange
 */
function AmountTemplate(props) {

    const [amountTemplate, setAmountTemplate] = useState({ amount: '', multiplier: 1 });

    const amountRef = useRef('');

    useEffect(() => {
        let amount = props.amount;
        /*
        if (amount === 'MAX_WALLET')
            amount = 'Max. Wallet';
        else if (amount === 'LAST_ORDER_QTY')
            amount = 'Last Order Qty.';
        */
        amount = getQuantityName(amount);

        setAmountTemplate({ amount, multiplier: props.multiplier });
    }, [props.amount, props.multiplier]);

    function onAmountChange(event) {
        let value = event.target.value;
        /*
        if (value === 'Max. Wallet')
            value = 'MAX_WALLET';
        else if (value === 'Last Order Qty.')
            value = 'LAST_ORDER_QTY';
        */
        value = getQuantityValue(value);

        props.onChange(getEventObject(event.target.id, value));
    }

    function clearAmount(event) {
        amountTemplate.amount = '';
        amountRef.current.value = '';
    }

    return (
        <div className="form-group">
            <label htmlFor="amount">Valor: <span data-bs-toggle='tooltip' data-bs-placement='top' title='Max. Wallet saca tudo disponível. Multiplicar por 1 = 100%' className="badge bg-warning py-1">?</span></label>
            <div className="input-group">
                <input ref={amountRef} id='amount' type='text' list='amountOptions' className="form-control w-50" onChange={onAmountChange} placeholder="0" value={getValueOrDefault(amountTemplate.amount)} />
                <span className="input-group-text bg-secondary" onClick={clearAmount} title='Clique para limpar o valor'>X</span>
                <input id='amountMultiplier' type='number' className="form-control" onChange={props.onChange} placeholder="1" value={amountTemplate.amountMultiplier} />
                <datalist id='amountOptions'>
                    <option>{quantityTypeNames.LAST_ORDER_QTY}</option>
                    <option>{quantityTypeNames.MAX_WALLET}</option>
                    <option>{quantityTypeNames.PROFIT_SKIM}</option>
                </datalist>
            </div>
        </div>
    )
}

export default AmountTemplate;
